import 'css-chunksrc/client/scenes/constraintEdition/constrainedElement/element/task/styles.scss';export default {
  "task": "_task_1gs1z_1",
  "completed": "_completed_1gs1z_9",
  "late": "_late_1gs1z_9",
  "unScheduled": "_unScheduled_1gs1z_13",
  "withStartDate": "_withStartDate_1gs1z_17",
  "withEndDate": "_withEndDate_1gs1z_21"
};